import ParositasAdatlapTableService from 'app/admin/parositasadatlap/service/ParositasAdatlapTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'parositasAdatlapTable',
	text: 'Parositas Adatlap',
	textKey: 'pairing',
	service: ParositasAdatlapTableService,
	icon: 'person',
	editFormState: item => `/parositasadatlap/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			text: 'Vizsga',
			propertyName: 'vizsgaAdatlap',
			propertyType: 'Long',
			type: 'EQ'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'adatlapFilename',
			text: 'Adatlap fájlnév',
			textKey: 'adatlapFilename',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function ParositasAdatlapTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('parositasAdatlapTable', reducer('parositasAdatlapTable'))(ParositasAdatlapTable);
